export const GRID_TITLE_PACHI_MOBILE = [
  {
    id: 1,
    name1: 'アウト',
    key: 'out',
    koumokuKey: 'koumoku1',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 2,
    name1: '台売上',
    key: 'uriage',
    koumokuKey: 'koumoku2',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 3,
    name1: '台粗利',
    key: 'arari',
    koumokuKey: 'koumoku3',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 4,
    name1: '玉単価',
    key: 'tama_tanka',
    koumokuKey: 'koumoku4',
    decimalPoint: 2,
    rowPos: 0
  },
  {
    id: 5,
    name1: '玉粗利',
    key: 'tama_arari',
    koumokuKey: 'koumoku5',
    decimalPoint: 2,
    rowPos: 0
  },
  {
    id: 6,
    name1: '中古価格',
    key: 'used_machine_price',
    koumokuKey: 'koumoku6',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 7,
    name1: '増減',
    key: 'zogen_used_machine_price',
    koumokuKey: 'koumoku7',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 8,
    name1: '平均',
    name2: '設置台数',
    key: 'display_heikin_daisu',
    koumokuKey: 'koumoku8',
    decimalPoint: 2,
    rowPos: 1
  },
  {
    id: 9,
    name1: 'スタート',
    key: 'start',
    koumokuKey: 'koumoku9',
    decimalPoint: 2,
    rowPos: 1
  },
  {
    id: 10,
    name1: 'S1',
    key: 'S1',
    koumokuKey: 'koumoku10',
    decimalPoint: 2,
    rowPos: 1
  },
  {
    id: 11,
    name1: 'ベース',
    key: 'base',
    koumokuKey: 'koumoku11',
    decimalPoint: 2,
    rowPos: 1
  },
  {
    id: 12,
    name1: 'BY',
    key: 'BY',
    koumokuKey: 'koumoku12',
    decimalPoint: 2,
    rowPos: 1
  },
  {
    id: 13,
    name1: 'BYmin',
    key: 'BYmin',
    koumokuKey: 'koumoku13',
    decimalPoint: 2,
    rowPos: 1
  },
  {
    id: 14,
    name1: 'T1Y',
    key: 'T1Y',
    koumokuKey: 'koumoku14',
    decimalPoint: 0,
    rowPos: 1
  },
  {
    id: 15,
    name1: 'TY',
    key: 'TY',
    koumokuKey: 'koumoku15',
    decimalPoint: 0,
    rowPos: 2
  },
  {
    id: 16,
    name1: '250玉',
    name2: 'スタート',
    key: '250tama_start',
    koumokuKey: 'koumoku16',
    decimalPoint: 2,
    rowPos: 2
  },
  {
    id: 17,
    name1: '初当確率',
    key: 'TS',
    koumokuKey: 'koumoku17',
    decimalPoint: 2,
    rowPos: 2
  },
  {
    id: 18,
    name1: 'SA',
    key: 'SA',
    koumokuKey: 'koumoku18',
    decimalPoint: 2,
    rowPos: 2
  },
  {
    id: 19,
    name1: 'BA',
    key: 'BA',
    koumokuKey: 'koumoku19',
    decimalPoint: 2,
    rowPos: 2
  },
  {
    id: 20,
    name1: 'TO',
    key: 'TO',
    koumokuKey: 'koumoku20',
    decimalPoint: 0,
    rowPos: 2
  },
  {
    id: 21,
    name1: 'T1O',
    key: 'T1O',
    koumokuKey: 'koumoku21',
    decimalPoint: 0,
    rowPos: 2
  },
  {
    id: 22,
    name1: '客滞率',
    key: 'kyakutai_ritsu',
    koumokuKey: 'koumoku22',
    decimalPoint: 2,
    rowPos: 3
  },
  {
    id: 23,
    name1: 'メーカー',
    key: 'brand_display_name',
    koumokuKey: 'koumoku23',
    decimalPoint: null,
    rowPos: 3
  },
  {
    id: 24,
    name1: 'タイプ',
    key: 'type_display_name',
    koumokuKey: 'koumoku24',
    decimalPoint: null,
    rowPos: 3
  },
  {
    id: 25,
    name1: '設置台数',
    key: 'display_total_daisu',
    koumokuKey: 'koumoku25',
    decimalPoint: 0,
    rowPos: 3
  }
];

export const GRID_TITLE_SLOT_MOBILE = [
  {
    id: 1,
    name1: 'アウト',
    key: 'out',
    koumokuKey: 'koumoku1',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 2,
    name1: '台売上',
    key: 'uriage',
    koumokuKey: 'koumoku2',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 3,
    name1: '台粗利',
    key: 'arari',
    koumokuKey: 'koumoku3',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 4,
    name1: 'メダル単価',
    key: 'tama_tanka',
    koumokuKey: 'koumoku4',
    decimalPoint: 2,
    rowPos: 0
  },
  {
    id: 5,
    name1: 'メダル粗利',
    key: 'tama_arari',
    koumokuKey: 'koumoku5',
    decimalPoint: 2,
    rowPos: 0
  },
  {
    id: 6,
    name1: '中古価格',
    key: 'used_machine_price',
    koumokuKey: 'koumoku6',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 7,
    name1: '増減',
    key: 'zogen_used_machine_price',
    koumokuKey: 'koumoku7',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 8,
    name1: '平均',
    name2: '設置台数',
    key: 'display_heikin_daisu',
    koumokuKey: 'koumoku8',
    decimalPoint: 2,
    rowPos: 1
  },
  {
    id: 9,
    name1: '平均',
    name2: '段階設定',
    key: 'heikin_dankai_settei',
    koumokuKey: 'koumoku9',
    decimalPoint: 2,
    rowPos: 1
  },
  {
    id: 10,
    name1: '出玉率',
    key: 'dedama_ritsu',
    koumokuKey: 'koumoku10',
    decimalPoint: 2,
    rowPos: 1
  },
  {
    id: 11,
    name1: '50枚G数',
    key: 'game_50mai',
    koumokuKey: 'koumoku11',
    decimalPoint: 0,
    rowPos: 1
  },
  {
    id: 12,
    name1: 'TY',
    key: 'TY',
    koumokuKey: 'koumoku12',
    decimalPoint: 0,
    rowPos: 1
  },
  {
    id: 13,
    name1: '最大出玉数',
    key: 'saidai_dedamasu',
    koumokuKey: 'koumoku13',
    decimalPoint: 0,
    rowPos: 1
  },
  {
    id: 14,
    name1: '最大吸込数',
    key: 'saidai_suikomisu',
    koumokuKey: 'koumoku14',
    decimalPoint: 0,
    rowPos: 1
  },
  {
    id: 15,
    name1: '客滞率',
    key: 'kyakutai_ritsu',
    koumokuKey: 'koumoku15',
    decimalPoint: 2,
    rowPos: 2
  },
  {
    id: 16,
    name1: 'メーカー',
    key: 'brand_display_name',
    koumokuKey: 'koumoku16',
    decimalPoint: null,
    rowPos: 2
  },
  {
    id: 17,
    name1: 'タイプ',
    key: 'type_display_name',
    koumokuKey: 'koumoku17',
    decimalPoint: null,
    rowPos: 2
  },
  {
    id: 18,
    name1: '設置台数',
    key: 'display_total_daisu',
    koumokuKey: 'koumoku18',
    decimalPoint: 0,
    rowPos: 2
  }
];

// ========================
// 一覧表示用
// ========================
export const GRID_TITLE_PACHI_MOBILE_SUMMARY = [
  {
    id: 1,
    name: 'アウト',
    key: 'out',
    koumokuKey: 'koumoku1',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 2,
    name: '台売上',
    key: 'uriage',
    koumokuKey: 'koumoku2',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 3,
    name: '台粗利',
    key: 'arari',
    koumokuKey: 'koumoku3',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 4,
    name: '玉単価',
    key: 'tama_tanka',
    koumokuKey: 'koumoku4',
    decimalPoint: 2,
    rowPos: 0
  },
  {
    id: 5,
    name: '玉粗利',
    key: 'tama_arari',
    koumokuKey: 'koumoku5',
    decimalPoint: 2,
    rowPos: 0
  },
  {
    id: 6,
    name: '中古価格',
    key: 'used_machine_price',
    koumokuKey: 'koumoku6',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 7,
    name: '増減',
    key: 'zogen_used_machine_price',
    koumokuKey: 'koumoku7',
    decimalPoint: 0,
    rowPos: 0
  }
];

export const GRID_TITLE_SLOT_MOBILE_SUMMARY = [
  {
    id: 1,
    name: 'アウト',
    key: 'out',
    koumokuKey: 'koumoku1',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 2,
    name: '台売上',
    key: 'uriage',
    koumokuKey: 'koumoku2',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 3,
    name: '台粗利',
    key: 'arari',
    koumokuKey: 'koumoku3',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 4,
    name: 'メダル単価',
    key: 'tama_tanka',
    koumokuKey: 'koumoku4',
    decimalPoint: 2,
    rowPos: 0
  },
  {
    id: 5,
    name: 'メダル粗利',
    key: 'tama_arari',
    koumokuKey: 'koumoku5',
    decimalPoint: 2,
    rowPos: 0
  },
  {
    id: 6,
    name: '中古価格',
    key: 'used_machine_price',
    koumokuKey: 'koumoku6',
    decimalPoint: 0,
    rowPos: 0
  },
  {
    id: 7,
    name: '増減',
    key: 'zogen_used_machine_price',
    koumokuKey: 'koumoku7',
    decimalPoint: 0,
    rowPos: 0
  }
];
